export default __webpack_public_path__ + "static/media/tree.fbe6a42d.png";